(function () {
  'use strict';
  const ANGLES = Object.freeze({
    default: {
      eyebrow: 'COMIDA HÚMEDA · RECETAS COMPLETAS',
      headline: 'Su comida,',
      emphasis: 'resuelta.',
      lead: 'Comida completa, su ración calculada y alguien a quien preguntar. Tú disfrutas de tu gato.',
      proof: 'Conoce qué lleva, qué llega primero y cómo continúa.',
      finish: 'Su ración. Sus recetas. Todo claro.'
    },
    quisquilloso: {
      eyebrow: 'PARA GATOS SELECTIVOS',
      headline: '¿Otro tarro que',
      emphasis: 'se queda en el plato?',
      lead: 'Comida completa, una guía paso a paso y una veterinaria a quien preguntar.',
      proof: 'Tienes 21 días desde tu pedido para probar hasta 3 tarros. Consulta las condiciones de la garantía.',
      finish: 'Descubre su primera caja y cuánto cuesta.'
    },
    multigato: {
      eyebrow: 'VARIOS GATOS · UN PLAN PARA CASA',
      headline: 'Cada gato es distinto.',
      emphasis: 'Su ración también.',
      lead: 'Su ración individual. Una caja para casa. Y menos cuentas para ti.',
      proof: 'Verás qué corresponde a cada gato y qué contiene cada caja.',
      finish: 'Cada uno, su ración. Tú, todo claro.'
    },
    'sin-congelador': {
      eyebrow: 'COMIDA HÚMEDA · SIN CONGELADOR',
      headline: 'De la despensa',
      emphasis: 'a su cuenco.',
      lead: 'Comida completa, lista para servir. Sin cocinar, sin descongelar, sin cambiar vuestros planes.',
      proof: 'Comida lista para servir, con la cantidad que le corresponde.',
      finish: 'Su comida resuelta. Sin descongelar.'
    },
    calidad: {
      eyebrow: 'SABER QUÉ COME EMPIEZA AQUÍ',
      headline: 'Conoce lo que lleva.',
      emphasis: 'Calcula lo que necesita.',
      lead: 'Comida completa, cocinada en el País Vasco. Ingredientes a la vista y su ración calculada.',
      proof: 'Los ingredientes y las recetas están a la vista antes de decidir.',
      finish: 'Ingredientes a la vista. Ración calculada.'
    },
    hidratacion: {
      eyebrow: 'COMIDA HÚMEDA PARA SU DÍA A DÍA',
      headline: 'Más comida húmeda.',
      emphasis: 'A su ritmo.',
      lead: 'Para combinar con su comida habitual o como plan completo. Tú eliges cómo empezar.',
      proof: 'Elige cómo incorporarla y revisa cuánto necesita en su plan.',
      finish: 'Encuentra su forma de empezar.'
    },
    emocional: {
      eyebrow: 'CUIDARLO TAMBIÉN ESTÁ EN SU CUENCO',
      headline: 'Lo conoces como nadie.',
      emphasis: 'Hagamos su plan.',
      lead: 'Comida completa, su ración calculada y un equipo para acompañarte. Cada día, un poco más fácil.',
      proof: 'Su perfil orienta las cantidades; tú eliges cómo empezar.',
      finish: 'Un plan que empieza por conocerlo.'
    },
    garantia: {
      eyebrow: 'COMIDA HÚMEDA · RECETAS COMPLETAS',
      headline: 'Su nueva comida.',
      emphasis: 'Con 21 días de garantía.',
      lead: 'Empieza poco a poco, con acompañamiento. Garantía de 21 días desde tu pedido en tu primer plan: la devolución la pagamos nosotros.',
      proof: 'Consulta aquí el plazo, los tarros que puedes probar y el reembolso.',
      finish: 'Conoce su primera caja. Empieza a su ritmo.'
    }
  });

  // Foto de portada por ángulo. Todas son fotos propias ya publicadas en la tienda
  // (nunca ECOMMERCE_* ni fotos de reseñas con problemas; ver memoria de imágenes).
  const IMAGES = Object.freeze({
    default: {file: 'landing-gato-torre-hd-1x1.jpg', width: 3660, height: 3660, alt: 'Gato british shorthair dorado junto a los cuatro tarros de Chef Miau', caption: 'Cuatro recetas', size: '320 g'},
    quisquilloso: {file: 'cm-pdp-pollo-lifestyle.png', width: 644, height: 799, alt: 'Un gato acercándose a un tarro abierto de Pollo y Calabaza', caption: 'Pollo y Calabaza', size: '320 g'},
    multigato: {file: 'landing-gato-torre-hd-1x1.jpg', width: 3660, height: 3660, alt: 'Gato british shorthair dorado junto a los cuatro tarros de Chef Miau', caption: 'Un plan para casa', size: '4 recetas'},
    'sin-congelador': {file: 'WebsiteImages_36eb9710-ef5e-4aac-84ae-a10b75f92181.png', width: 1200, height: 1200, alt: 'Tres tarros cerrados de Chef Miau en la encimera de una cocina', caption: 'En la despensa', size: '320 g'},
    calidad: {file: 'mix_be3cf328-c422-4793-8d73-49e5f7f7a938.png', width: 1080, height: 1080, alt: 'Tarros de Chef Miau junto a los ingredientes de cada receta', caption: 'Lo que lleva', size: '320 g'},
    hidratacion: {file: 'cm-pdp-food-bowl.webp', width: 644, height: 799, alt: 'Cuenco con comida húmeda de Chef Miau', caption: 'Comida húmeda', size: '320 g'},
    emocional: {file: 'landing-emocional-abrazo-hd-4x5.jpg', width: 2060, height: 2575, alt: 'Una persona abraza a un gato dorado y le da un beso', caption: 'En casa', size: ''},
    garantia: {file: '11.png', width: 1200, height: 1200, alt: 'Un gato asomado a la caja de Chef Miau', caption: 'Tu primera caja', size: ''}
  });
  const IMAGE_BASE = 'https://chefmiau.com/cdn/shop/files/';
  // CM-IMGCRO-8OCT: el paso 3 del ángulo garantía conserva su imagen; la portada general pasa a la foto de estudio.
  const STEP_FOUR_RECIPES = Object.freeze({file: 'cm-growth-four-recipes-1080-20260916.png', alt: 'Las cuatro recetas de Chef Miau en tarros de cristal de 320 g'});
  // CM-IMGCRO-V4: brazo «lifestyle» del test de la foto de arriba: la misma foto en todos los ángulos; su titular
  // y su texto solo en la portada general (los ángulos de anuncio conservan los suyos).
  const HERO_LIFESTYLE = Object.freeze({copy: {headline: 'Es de casa.', emphasis: 'Que coma como en casa.', lead: 'Comida completa, su ración calculada y alguien a quien preguntar. Tú disfrutas de tu gato.'}, image: {file: 'camiseta-abrazo-hd-4x5.jpg', width: 3040, height: 3800, alt: 'Persona de espaldas con la camiseta El toque final abrazando a un gato dorado', caption: 'En casa', size: ''}});

  // Brief evidence beside the decision; recipe figures match the existing recipe data.
  const CONTEXT = Object.freeze({
    default: {title: 'Primero el cambio. Después su rutina.', body: 'La primera caja acompaña la transición. En el resultado verás también los tarros y el precio de las entregas mensuales.'},
    quisquilloso: {title: 'No hace falta cambiarlo todo de golpe.', body: 'Empieza junto a su comida habitual, con una guía de 21 días y una videollamada incluida. Si no le convence, tienes 21 días desde tu pedido, hasta el día en que sale tu caja del mes: abre hasta 3 tarros y te lo devolvemos todo.', link: 'Ver condiciones de la garantía', href: 'https://chefmiau.com/pages/garantia'},
    multigato: {title: 'Cada gato, su parte de la caja.', body: 'Verás las cantidades y recetas de cada gato por separado. Las exclusiones de uno se aplican a su reparto, sin imponerse al resto.'},
    'sin-congelador': {title: 'Cerrado, despensa. Abierto, nevera.', body: 'Los tarros llegan listos para servir. Guárdalos cerrados en la despensa y, una vez abiertos, bien tapados hasta cuatro días en la nevera.'},
    calidad: {title: 'Dentro del tarro de Pollo con calabaza', body: '51% pechuga · 16% mollejas · 16% corazón · 7% hígado · 9% calabaza · 1% lino.', link: 'Ver todas las recetas', href: 'https://chefmiau.com/pages/recetas'},
    hidratacion: {title: 'Comida húmeda, de dos formas.', body: 'Puedes combinarla con su comida habitual o elegir un plan completo. Al cambiar de modalidad en el resultado, verás cómo se ajustan sus cantidades y precios.'},
    emocional: {title: 'Su perfil orienta el plan.', body: 'Peso, edad y actividad ayudan a calcular su ración. Las exclusiones que indiques se mantienen al elegir sus recetas.'},
    garantia: {title: 'Qué cubre la primera prueba', body: 'Tienes 21 días desde tu pedido, hasta el día en que sale tu caja del mes. Puedes abrir hasta 3 tarros; el resto debe seguir cerrado. Te devolvemos todo lo que pagaste y la devolución la pagamos nosotros.', link: 'Ver las condiciones', href: 'https://chefmiau.com/pages/garantia'}
  });

  let root = null;
  let activeAngle = 'default';
  let reviewProof = null;

  // Match what the customer actually describes, not generic praise such as "natural".
  // Some angles deliberately fall back to a general opinion when no source supports them.
  const REVIEW_CONTEXT = Object.freeze({
    default: [/les ha encantado|le ha encantado|les encanta|le encanta|se lo com/iu],
    quisquilloso: [/\b(?:exigentes?|quisquillos[oa]s?|delicad[oa]s?|selectiv[oa]s?)\b/iu, /\b(?:primera vez|empec[eé]|empezamos|empezaron)\b/iu],
    multigato: [/\b(?:mis gatos|mis gatas|dos gatos|dos gatas|tres gatos|tres gatas|entre los dos)\b/iu],
    'sin-congelador': [/\b(?:despensa|sin congelador|sin descongelar)\b/iu],
    calidad: [/\b(?:ves exactamente lo que lleva|se ven los ingredientes|leo la etiqueta|leo los ingredientes)\b/iu, /\b(?:ingredientes|composici[oó]n|etiqueta)\b/iu],
    hidratacion: [/\b(?:caldo|humedad)\b/iu],
    emocional: [/\b(?:mi peque[nñ]a|mi peque[nñ]o|mis peque[nñ]os|mi compa[nñ]ero|parte de la familia)\b/iu],
    garantia: [/\b(?:me devolvieron|nos devolvieron|recib[ií] el reembolso|us[eé] la garant[ií]a|utilic[eé] la garant[ií]a)\b/iu]
  });

  function suppliedVoices(proof) {
    if (!proof || typeof proof !== 'object') return [];
    return [proof.latest,
      ...(Array.isArray(proof.contextVoices) ? proof.contextVoices : []),
      ...(Array.isArray(proof.recentVoices) ? proof.recentVoices : [])];
  }

  function landingReview(proof, angle) {
    const seen = new Set();
    const candidates = suppliedVoices(proof).filter(voice => {
      if (!voice || voice.verified !== true || typeof voice.quote !== 'string' || typeof voice.reviewer !== 'string') return false;
      const quote = voice.quote.trim(), reviewer = voice.reviewer.trim();
      // Keep the entire supplied review, including qualifications. A clipped or long
      // review is skipped rather than shortened into a more favourable statement.
      if (!reviewer || !quote || quote.length > 220 || /(?:\.{3}|…)\s*$/u.test(quote)) return false;
      if (/no le gust|no les gust|no quiso|no quiere|no lo prob|vomit/iu.test(quote)) return false;
      const key = reviewer.toLocaleLowerCase('es') + '\n' + quote;
      if (seen.has(key)) return false;
      seen.add(key); return true;
    });
    const rules = REVIEW_CONTEXT[angle] || REVIEW_CONTEXT.default;
    let winner = null, best = 0;
    for (const voice of candidates) {
      const quote = voice.quote.trim();
      const score = rules.reduce((total, pattern, index) => total + (pattern.test(quote) ? rules.length - index : 0), 0);
      if (score > best) { best = score; winner = voice; }
    }
    const selected = winner || candidates.find(voice => voice.quote.trim().length >= 25) || candidates[0];
    return selected ? { quote: selected.quote.trim(), reviewer: selected.reviewer.trim(), context: winner ? angle : 'general' } : null;
  }

  function text(selector, value) {
    const element = root && root.querySelector(selector);
    if (element && element.textContent !== value) element.textContent = value;
  }

  // CM-IMGCRO-8OCT (A15 + A1 + A3). En móvil la foto es una miniatura de 112×145 (90×130 bajo 360 px): se piden
  // 240-480 px en vez de 768-1200. Un ángulo puede traer su propio archivo para móvil (mobile): va en el <source>
  // del <picture>, así el navegador elige desde el primer momento. Se incluyen tamaños nativos: ampliar en el
  // CDN no recupera detalle.
  const VISUAL_MEDIA = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 700px)') : null;
  let visualBound = false;
  function visualCandidates(source) {
    const widths = [240, 360, 480, 640, 768, 960, 1200, 1600, 1920, 2560, 3200].filter(width => width < source.width);
    widths.push(source.width);
    return widths.map(width => IMAGE_BASE + source.file + '?width=' + width + ' ' + width + 'w').join(', ');
  }
  function visualThumb(source) {
    // CM-IMGCRO-V4: en móvil la foto ocupa todo el ancho con un alto fijo y ninguna es tan apaisada como para pedir más.
    return '100vw';
  }
  function applyVisual(image) {
    const photo = root && root.querySelector('[data-cmg2-visual-photo]');
    if (!photo || typeof photo.setAttribute !== 'function') return;
    // CM-IMGCRO-V4: si el script de la sección ya puso esta foto antes del primer pintado, no se toca ni se descarga otra vez.
    const heroKey = image.file + '|' + (image.mobile ? image.mobile.file : '');
    if (photo.getAttribute('data-cm-hero-key') === heroKey) return;
    photo.setAttribute('data-cm-hero-key', heroKey);
    const mobileSource = root.querySelector('[data-cmg2-visual-source]');
    // Sin <picture> (marcado antiguo), se elige el archivo por el ancho de la ventana.
    const main = image.mobile && !mobileSource && VISUAL_MEDIA && VISUAL_MEDIA.matches ? image.mobile : image;
    const nextSrc = IMAGE_BASE + main.file + '?width=' + Math.min(1200, main.width);
    photo.setAttribute('sizes', '(max-width: 700px) ' + visualThumb(main) + ', ' + Math.ceil(Math.max(550, 570 * main.width / main.height)) + 'px');
    photo.setAttribute('srcset', visualCandidates(main));
    if (photo.getAttribute('src') !== nextSrc) photo.setAttribute('src', nextSrc);
    photo.setAttribute('width', String(main.width));
    photo.setAttribute('height', String(main.height));
    photo.setAttribute('alt', image.alt);
    if (mobileSource) {
      const small = image.mobile || image;
      mobileSource.setAttribute('media', '(max-width: 700px)');
      mobileSource.setAttribute('srcset', visualCandidates(small));
      mobileSource.setAttribute('sizes', visualThumb(small));
    } else if (!visualBound && VISUAL_MEDIA) {
      visualBound = true;
      const onChange = () => { const current = IMAGES[activeAngle] || IMAGES.default; if (current.mobile) applyVisual(current); };
      if (typeof VISUAL_MEDIA.addEventListener === 'function') VISUAL_MEDIA.addEventListener('change', onChange);
      else if (typeof VISUAL_MEDIA.addListener === 'function') VISUAL_MEDIA.addListener(onChange);
    }
  }

  function setAngle(angle) {
    root = document.getElementById('cm-growth-entry');
    if (!root) return 'default';
    activeAngle = Object.prototype.hasOwnProperty.call(ANGLES, angle) ? angle : 'default';
    const lifestyle = root.getAttribute('data-cm-hero') === 'lifestyle';
    const copy = lifestyle && activeAngle === 'default' ? Object.assign({}, ANGLES[activeAngle], HERO_LIFESTYLE.copy) : ANGLES[activeAngle];
    text('[data-cmg2-eyebrow]', copy.eyebrow);
    text('[data-cmg2-headline]', copy.headline);
    text('[data-cmg2-headline-em]', copy.emphasis);
    text('[data-cmg2-lead]', copy.lead);
    text('[data-cmg2-angle-proof]', copy.proof);
    text('[data-cmg2-finish]', copy.finish);
    const context = CONTEXT[activeAngle];
    text('[data-cmg2-context-title]', context.title);
    text('[data-cmg2-context-body]', context.body);
    const contextLink = root.querySelector('[data-cmg2-context-link]');
    if (contextLink) {
      contextLink.hidden = !context.href;
      if (context.href) {
        contextLink.href = context.href;
        contextLink.textContent = context.link + ' ↗';
      }
    }
    const warrantyLink = root.querySelector('[data-cmg2-warranty-link]');
    if (warrantyLink) warrantyLink.hidden = activeAngle !== 'garantia';
    const image = (lifestyle && HERO_LIFESTYLE.image) || IMAGES[activeAngle] || IMAGES.default;
    applyVisual(image);
    text('[data-cmg2-visual-caption]', image.caption);
    const size = root.querySelector('[data-cmg2-visual-size]');
    if (size) { size.textContent = image.size; size.hidden = !image.size; }
    root.dataset.angle = activeAngle;
    const stepCat = root.querySelector('[data-cmg2-step-cat]');
    if (stepCat) {
      stepCat.src = IMAGE_BASE + 'DSCF7745_Maya.jpg?width=600';
      stepCat.alt = 'Maya, la gata de Chef Miau';
    }
    const stepFood = root.querySelector('[data-cmg2-step-food]');
    if (stepFood) {
      stepFood.src = IMAGE_BASE + (activeAngle === 'calidad' ? 'INTERNAL_USE_Brand_Social_1.jpg' : IMAGES.calidad.file) + '?width=600';
      stepFood.alt = activeAngle === 'calidad' ? 'Ingredientes de la receta de pollo con calabaza' : IMAGES.calidad.alt;
    }
    const stepBox = root.querySelector('[data-cmg2-step-box]');
    if (stepBox) {
      const chosen = activeAngle === 'garantia' ? STEP_FOUR_RECIPES : IMAGES.garantia;
      stepBox.src = IMAGE_BASE + chosen.file + '?width=600'; stepBox.alt = chosen.alt;
    }
    renderJourney(activeAngle);
    renderReview(reviewProof);
    return activeAngle;
  }

  function renderReview(review) {
    const box = root.querySelector('[data-cmg2-proof]');
    if (!box) return;
    box.hidden = true;
    const trust = root.querySelector('[data-cmg2-trustline]');
    if (trust) trust.hidden = true;
    text('[data-cmg2-quote]', '');
    text('[data-cmg2-reviewer]', '');
    delete box.dataset.reviewContext;
    const verified = root.querySelector('[data-cmg2-verified]');
    if (verified) verified.hidden = true;
    const voicesBox = root.querySelector('[data-cmg2-voices]');
    if (voicesBox) voicesBox.hidden = true;
    const selected = landingReview(review, activeAngle);
    if (!review || !selected) return;
    const rating = Number(String(review.rating || '').replace(',', '.'));
    const count = Number(review.count);
    if (!(rating > 0 && rating <= 5) || !Number.isInteger(count) || count < 1) return;
    const positive=Number(review.positiveCount),total=Number(review.ratingCount);
    const validPositive=Number.isInteger(positive)&&Number.isInteger(total)&&total===count&&positive>=0&&positive<=total;
    /* Tanda 18 (28-sep-2026): la frase sale de growthClaims.ts; sin el dato de devoluciones en pantalla. */
    text('[data-cmg2-rating]', '★ ' + rating.toLocaleString('es-ES', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + ' de 5 · ' + (count > 10 ? 'más de ' + (count > 100 ? Math.floor((count - 1) / 100) * 100 : Math.floor((count - 1) / 10) * 10) : count) + ' opiniones'); /* reviews-v2: media y "más de N" */
    text('[data-cmg2-review-count]', 'Ver reseñas');
    const stars = root.querySelector('[data-cmg2-stars]');
    if (stars) { stars.style.setProperty('--star-fill', (rating * 20) + '%'); stars.setAttribute('aria-label', 'Valoración media: ' + rating.toLocaleString('es-ES') + ' de 5 estrellas'); }
    if (trust) trust.hidden = false;
    text('[data-cmg2-quote]', '«' + selected.quote + '»');
    text('[data-cmg2-reviewer]', selected.reviewer);
    if (verified) verified.hidden = false;
    box.dataset.reviewContext = selected.context;
    if(voicesBox){
      const seen=new Set();
      const allVoices=[...(Array.isArray(review.recentVoices)?review.recentVoices:[]),...(Array.isArray(review.contextVoices)?review.contextVoices:[])].filter(v=>{const name=typeof v?.reviewer==='string'?v.reviewer.trim():'';if(!name||v.verified!==true||seen.has(name.toLowerCase()))return false;seen.add(name.toLowerCase());return true;});
      const voices=allVoices.slice(0,3);
      const avatars=root.querySelector('[data-cmg2-avatars]');
      if(avatars){
        avatars.replaceChildren();
        for(const voice of voices){const avatar=document.createElement('span');avatar.textContent=voice.reviewer.trim().slice(0,1).toUpperCase();avatars.append(avatar);}
      }
      const names=voices.map(v=>v.reviewer.trim());
      const people=allVoices.length>3 ? names.slice(0,2).join(', ')+' y otras familias' : names.slice(0,-1).join(', ')+' y '+names[names.length-1];
      text('[data-cmg2-voice-names]',voices.length>=2 ? people+' ya lo sirven en casa.' : '');
      voicesBox.hidden=voices.length<2;
    }
    const cards=root.querySelector('[data-cmg2-cards]');
    if(cards){
      const seenCards=new Set([selected.reviewer.trim().toLowerCase()]);
      const pool=[...(Array.isArray(review.recentVoices)?review.recentVoices:[]),...(Array.isArray(review.contextVoices)?review.contextVoices:[])].filter(v=>{
        if(!v||v.verified!==true||typeof v.quote!=='string'||typeof v.reviewer!=='string')return false;
        const q=v.quote.trim(),n=v.reviewer.trim().toLowerCase();
        /* Solo cinco estrellas y sin frases de rechazo: una reseña tibia no es prueba social. */
        if(Number(v.rating)!==5||/no le gust|no les gust|ninguno|una pena|no quiso|no quiere|no lo prob|vomit/iu.test(q))return false;
        if(!n||q.length<25||q.length>220||/(?:\.{3}|…)\s*$/u.test(q)||seenCards.has(n))return false;
        seenCards.add(n);return true;});
      const extra=pool.slice(0,2);
      cards.replaceChildren();
      for(const v of extra){
        const card=document.createElement('article');card.className='cmg2-review-card';
        const st=document.createElement('span');st.className='cmg2-review-stars';st.textContent='★★★★★';st.setAttribute('aria-hidden','true');
        const r=Number(v.rating);if(r>0&&r<=5){st.style.setProperty('--star-fill',(r*20)+'%');}else{st.hidden=true;}
        const q=document.createElement('p');q.textContent='«'+v.quote.trim()+'»';
        const who=document.createElement('small');who.textContent=v.reviewer.trim()+' · Compra verificada';
        card.append(st,q,who);cards.append(card);
      }
      cards.hidden=extra.length===0;
    }
    text('[data-cmg2-proof-eyebrow]', count + ' opiniones en Judge.me'); /* reviews-1oct */
    box.hidden = false;
  }

  // Presentation only: neither query-string attribution nor quiz state is changed.
  const JOURNEY_COMPARISONS = {
    pienso:{label:'Pienso',note:"Ejemplo real: pienso de supermercado «con buey y pollo», con los datos de la etiqueta que publica su fabricante (octubre de 2026). Chef Miau: receta de Pollo + Calabaza. *Hidratos calculados a partir de la etiqueta y sobre materia seca, para comparar comida seca y húmeda en igualdad de condiciones.",rows:[['Primer ingrediente','Carne','Cereales'],['La carne del nombre','90% de pollo','1,6% de buey y 1,6% de pollo'],['Hidratos de carbono*','Menos del 2%','Más del 40%'],['Agua en el cuenco','77–80%','Menos del 14%'],['Su cantidad','Calculada según su perfil','Consulta la pauta del envase'],['Ayuda al empezar','Guía + videollamada incluidas','Según marca y servicio']]},
    sobres:{label:'Latas y sobres',note:"Ejemplo real: sobre de pollo en gelatina de 85 g, con los datos de la etiqueta que publica su fabricante (septiembre de 2026). Chef Miau: receta de Pollo + Calabaza.",rows:[['Carne total','90–91% de carne y vísceras','14% de «carnes y subproductos animales»'],['La carne del nombre','90% de pollo','8% de pollo'],['Ingredientes','Cada uno con su porcentaje','Por categorías'],['Su cantidad','Calculada según su perfil','Consulta la pauta del envase'],['Ayuda al empezar','Guía + videollamada incluidas','Según marca y servicio']]},
    congelado:{label:'Congelado',note:"Orientación por categorías, no sobre una marca concreta. Consulta la etiqueta y los servicios de cada producto.",rows:[['Antes de abrir','Despensa, sin congelador','Congelador'],['Para servir','Abrir y servir','Seguir la descongelación indicada'],['Su cantidad','Calculada según su perfil','Según producto y servicio'],['Ayuda al empezar','Guía + videollamada incluidas','Según marca y servicio']]}
  };
  const JOURNEY_ANGLES = {
    default:{title:'Otra forma de resolver su comida.',intro:'La diferencia no acaba en la receta: también tienes su cantidad calculada y ayuda para empezar.',compare:'pienso'},
    quisquilloso:{title:'Nueva comida. Sin cambiarlo todo de golpe.',intro:'Puedes empezar junto a su comida habitual. El plan calcula la parte de Chef Miau y te guía durante el cambio.',compare:'sobres'},
    multigato:{title:'Cada cuenco, con sus propias cuentas.',intro:'Un perfil y una ración para cada gato. Una caja para casa, sin perder de vista lo que corresponde a cada uno.',compare:'pienso'},
    'sin-congelador':{title:'La despensa también les da de comer.',intro:'Sin cocinar ni esperar a que se descongele. Cerrado, en la despensa; abierto, bien tapado hasta cuatro días en nevera.',compare:'congelado',photo:'WebsiteImages_36eb9710-ef5e-4aac-84ae-a10b75f92181.png',alt:'Tarros cerrados de Chef Miau en una cocina',caption:'Abres. Sirves. Y sigues.'},
    calidad:{title:'Mira la comida. Lee la receta.',intro:'Ingredientes y porcentajes publicados. Para saber qué sirves, además de cuánto servir.',compare:'sobres',photo:'mix_be3cf328-c422-4793-8d73-49e5f7f7a938.png',alt:'Tarros de Chef Miau con los ingredientes de sus recetas',caption:'Lo que lleva, a la vista.'},
    hidratacion:{title:'Comida húmeda, a vuestra manera.',intro:'Como parte de una alimentación mixta o como plan completo. En el resultado eliges y ves cómo cambian sus cantidades.',compare:'pienso'},
    emocional:{title:'Cuidarlo también es ponértelo fácil.',intro:'Comida preparada, cantidades calculadas y ayuda para las dudas del cambio. Más tiempo juntos, menos cuentas.',compare:'pienso'},
    garantia:{title:'Una forma acompañada de empezar.',intro:'Comida completa, guía gradual y videollamada incluidas. La primera caja tiene garantía de 21 días desde tu pedido: la devolución la pagamos nosotros.',compare:'sobres'}
  };
  function renderJourneyComparison(key) {
    const chosen=JOURNEY_COMPARISONS[key]||JOURNEY_COMPARISONS.pienso;
    text('[data-cmj-other]',chosen.label);
    if(chosen.note)text('[data-cmj-note]',chosen.note);
    const rows=root.querySelector('[data-cmj-rows]');
    if(!rows)return;
    rows.replaceChildren();
    chosen.rows.forEach(values=>{const row=document.createElement('tr');values.forEach((value,index)=>{const cell=document.createElement(index===0?'th':'td');if(index===0)cell.scope='row';cell.textContent=value;row.append(cell);});rows.append(row);});
    root.querySelectorAll('[data-cmj-compare]').forEach(button=>{const selected=button.dataset.cmjCompare===key;button.setAttribute('aria-selected',String(selected));button.tabIndex=selected?0:-1;});
    root.querySelector('#cmj-comparison-panel').setAttribute('aria-labelledby','cmj-tab-'+key);
  }
  function renderJourney(angle) {
    const copy=JOURNEY_ANGLES[angle]||JOURNEY_ANGLES.default;
    text('[data-cmj-title]',copy.title);text('[data-cmj-intro]',copy.intro);
    text('[data-cmj-caption]',copy.caption||'Así se ve. Así se sirve.');
    const photo=root.querySelector('[data-cmj-photo]');
    if(photo){photo.src=IMAGE_BASE+(copy.photo||'cm-pdp-food-bowl.webp')+'?width=768';photo.alt=copy.alt||'Comida de Chef Miau servida en un cuenco';}
    renderJourneyComparison(copy.compare);
    const comparison=root.querySelector('#cmj-compare'),acceptance=root.querySelector('#cmj-acceptance'),ingredients=root.querySelector('.cmf-composition'),anchor=root.querySelector('.cmg2-essentials'),offer=root.querySelector('#cmg2-transition-includes'),how=root.querySelector('.cmj-how'),faq=root.querySelector('.cmg2-faq');
    if(acceptance&&ingredients&&anchor&&offer){[acceptance,ingredients,offer].forEach(block=>anchor.before(block));if(comparison&&faq)faq.before(comparison);} /* landing-v5-bloques: la comparativa vive dentro de «Lo que pagas, por dentro» */
    if(root.dataset.cmjBound==='true')return;
    root.querySelectorAll('[data-cmj-compare]').forEach(button=>{
      button.addEventListener('click',()=>renderJourneyComparison(button.dataset.cmjCompare));
      button.addEventListener('keydown',event=>{const keys=Object.keys(JOURNEY_COMPARISONS),index=keys.indexOf(button.dataset.cmjCompare);let next=index;if(event.key==='ArrowRight')next=(index+1)%keys.length;else if(event.key==='ArrowLeft')next=(index+keys.length-1)%keys.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=keys.length-1;else return;event.preventDefault();renderJourneyComparison(keys[next]);root.querySelector('[data-cmj-compare="'+keys[next]+'"]').focus();});
    });
    root.dataset.cmjBound='true';
  }

  function init(options) {
    root = document.getElementById('cm-growth-entry');
    if (!root) return false;
    const settings = options || {};
    reviewProof = settings.config && settings.config.reviewProof;
    setAngle(settings.angle || 'default');
    if (root.dataset.cmg2Bound !== 'true') {
      root.addEventListener('click', function (event) {
        const explanation = event.target.closest('a[href="#cmg2-offer-details"], a[href="#cmg2-shipping-details"], a[href="#cmg2-guarantee-details"]');
        if (explanation && root.contains(explanation)) {
          const panel = root.querySelector(explanation.getAttribute('href'));
          if (panel) panel.open = true;
          return;
        }
        const button = event.target.closest('[data-cmg2-start]');
        if (!button || !root.contains(button)) return;
        window.dispatchEvent(new CustomEvent('cm-growth:start', {
          detail: {angle: activeAngle, source: button.closest('.cmg2-transition-includes') ? 'landing_inclusions' : button.closest('.cmg2-finish') ? 'landing_footer' : 'landing_hero'}
        }));
      });
      root.dataset.cmg2Bound = 'true';
    }
    return true;
  }

  window.CMGrowthLanding = Object.freeze({init: init, setAngle: setAngle});
}());
